export const DEFAULT_TEMPLATES = {
    wedding:
        "Dear {{name}},\n\nThank you so much for entrusting us with your wedding day enquiry. It would be our honour to help bring your celebration to life.\n\nCould you share a little more about your vision — venue, guest count, and any colours or traditions close to your heart? We'll follow with availability and next steps shortly.\n\nWarmly,\nLeemerh",
    proposal:
        "Dear {{name}},\n\nWhat a beautiful moment to be planning! Thank you for reaching out about your proposal.\n\nTo help us design something unforgettable, could you tell us a little more about the setting you have in mind and your preferred date? We'll be in touch with ideas and availability soon.\n\nWarmly,\nLeemerh",
    party:
        "Dear {{name}},\n\nThank you for your enquiry about your celebration — we'd love to help make it special.\n\nCould you share a few more details on the occasion, guest count and date you have in mind? We'll follow up shortly with availability and ideas.\n\nWarmly,\nLeemerh",
    general:
        "Dear {{name}},\n\nThank you for your enquiry with Events by Leemerh. We're delighted you're considering us for your celebration.\n\nWe'll review your details and be in touch very soon with next steps.\n\nWarmly,\nLeemerh",
};

export const TEMPLATE_LABELS = {
    wedding: "Wedding",
    proposal: "Proposal",
    party: "Party / Celebration",
    general: "General",
};

const STORAGE_KEY = "ebl_reply_templates";

export const loadTemplates = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return { ...DEFAULT_TEMPLATES };
        return { ...DEFAULT_TEMPLATES, ...JSON.parse(raw) };
    } catch {
        return { ...DEFAULT_TEMPLATES };
    }
};

export const saveTemplates = (templates) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(templates));
};

export const matchTemplateKey = (eventType = "") => {
    const t = eventType.toLowerCase();
    if (t.includes("proposal")) return "proposal";
    if (t.includes("wedding")) return "wedding";
    if (t.includes("party") || t.includes("parties") || t.includes("celebration") || t.includes("birthday")) return "party";
    return "general";
};

export const fillTemplate = (template, name) =>
    (template || "").replace(/{{\s*name\s*}}/gi, name ? name.split(" ")[0] : "there");
